import { render, staticRenderFns } from "./Treasury.vue?vue&type=template&id=b6857bb0&"
import script from "./Treasury.vue?vue&type=script&lang=js&"
export * from "./Treasury.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports